// extracted by mini-css-extract-plugin
module.exports = {"placeholderAd":"awareness-ad_placeholderAd__l0ClL","buzzfeed":"awareness-ad_buzzfeed__sgVbG","buzzfeed_news":"awareness-ad_buzzfeed_news__PTiNm"};